import React from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router'

import { TopBar, Container, ViewerSkeleton } from 'splash/components'

const LoadingFlyer = ({
  intl: { messages },
  match: { params: { flyerId } },
}) => (
  <Container>
    <TopBar title={messages.catalogue_loading} />
    <ViewerSkeleton flyerId={flyerId} />
  </Container>
)

LoadingFlyer.propTypes = {
  intl: PropTypes.shape({
    locale: PropTypes.string.isRequired,
    messages: PropTypes.shape({
      catalogue_loading: PropTypes.string,
    }).isRequired,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      flyerId: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
}

export default withRouter(injectIntl(LoadingFlyer))
